import { createContext } from 'react';
import type UAParser from 'ua-parser-js';
import { type Config } from '#types.ts';

export type ToolbeltContext = {
  config: Config;
  uaParser: UAParser.IResult;
};

// Context requires an initial value, but this is set in the provider
// so casting to appease React bad typing.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const Context = createContext<ToolbeltContext>({} as ToolbeltContext);
